<template>
    <div class="public_container payable_details_wrap" v-loading="loading">
        <div class="returnNavBar">
            <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true"> </ReturnNavBar>
        </div>
        <div class="mobile_container">
            <div class="form_module_title">基本信息</div>
            <div class="form_module_content">
                <p>应付编号：{{ payableDetails.basic_info.payable_no }}</p>
                <template v-if="payableDetails.basic_info.source_type">
                    <template v-if="payableDetails.basic_info.source_type === 'purchase'">
                        <p>供应商名称：{{ payableDetails.detail && payableDetails.detail.supplier_name }}</p>
                        <p>
                            采购编号：<span class="link-label"
                                @click="handleClickRelateId((payableDetails.basic_info && payableDetails.basic_info.relate_type == 'purchase') ? payableDetails.basic_info.relate_id : '')">{{
                                    payableDetails.detail.purchase_no }}</span>
                        </p>
                    </template>
                    <template v-else-if="payableDetails.basic_info.source_type === 'order_return'">
                        <p>客户公司名称：<span class="link-label" @click="handleClickCustomerDetail(payableDetails.detail && payableDetails.detail.customer_info && payableDetails.detail.customer_info.id,
                            payableDetails.detail && payableDetails.detail.customer_info && payableDetails.detail.customer_info.name)">{{ payableDetails.detail &&
                                payableDetails.detail.customer_info && payableDetails.detail.customer_info.name }}</span></p>
                        <p>订单编号：<span class="link-label" @click="handleClickOrderDetail(payableDetails.detail.order_no)">{{ payableDetails.detail.order_no }}</span></p>
                    </template>
                </template>
                <p>审批编号：<span class="link-label" @click="handleClickApprovalDetail(payableDetails.basic_info.approval_id)">{{ payableDetails.basic_info.approval_id }}</span></p>
                <div class="mobile_detail_head_user_wrap">
                    申请人：
                    <div class="mobile_detail_head_user" v-if="payableDetails.basic_info && payableDetails.basic_info.uid_info"
                        @click="handleClickUserInfo(payableDetails.basic_info.uid_info)">
                        <img :src="payableDetails.basic_info.uid_info.avatar
                            ? payableDetails.basic_info.uid_info.avatar
                            : defaultImg
                            " alt="" />
                        <span class="ellipsis">{{
                            payableDetails.basic_info.uid_info && payableDetails.basic_info.uid_info.name
                        }}</span>
                    </div>
                </div>
                <p>申请时间：{{ payableDetails.basic_info && payableDetails.basic_info.apply_time }}</p>
            </div>
            <div class="form_module_title">金额信息</div>
            <div class="form_module_content">
                <p>应付金额：{{ Number(payableDetails.basic_info.payable_amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</p>
                <p>已付金额：{{ Number(payableDetails.basic_info.paid_amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</p>
                <template v-if="payableDetails.basic_info.payment_status == 3">
                    <p>取消付款金额：{{ Number(payableDetails.basic_info.unpaid_amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</p>
                </template>
                <template v-else>
                    <p>应付未付金额：{{ Number(payableDetails.basic_info.unpaid_amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</p>
                </template>
            </div>
            <div class="form_module_title">收款方信息</div>
            <div class="form_module_content">
                <p>开户名：{{ payableDetails.payee_info.account_name }}</p>
                <p>开户账号：{{ payableDetails.payee_info.account_number }}</p>
                <p>开户行：{{ payableDetails.payee_info.bank_name }}</p>
            </div>
            <template v-if="payableDetails.payment_records && payableDetails.payment_records.length > 0">
                <div class="form_module_title">支付记录</div>
                <ul>
                    <li>
                        <p>
                            支付总金额：{{
                                payableDetails.payment_records.reduce(
                                    (total, item) => total + Number(item.payment_amount),
                                    0
                                )
                            }}
                        </p>
                    </li>
                </ul>
                <ul>
                    <li v-for="row in payableDetails.payment_records">
                        <p>付款时间：{{ row.payment_time }}</p>
                        <p>
                            支付方式：{{
                                row.payment_method
                                    ? payTypeList.find((item) => item.value == row.payment_method).name
                                    : ""
                            }}
                        </p>
                        <p>支付金额：{{ Number(row.payment_amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</p>
                        <p>备注：{{ row.remarks }}</p>
                        <p>支付凭证：</p>
                        <div v-if="row.voucher && row.voucher.length">
                            <ul class="voucher_list">
                                <li :key="index" class="voucher_item" v-for="(item, index) in row.voucher" @click="handleClickPreviewImg(index, row.voucher)">
                                    <van-image :src="item" alt=""> </van-image>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </template>
            <template v-if="payableBatchPayInfo.length > 0">
                <div class="form_module_title">合并支付记录</div>
                <ul>
                    <li>
                        <p>应付总金额：{{ Number(payableDetails.basic_info.payable_amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</p>
                        <p>支付总金额：{{ Number(payableDetails.basic_info.paid_amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</p>
                    </li>
                </ul>
                <ul>
                    <template v-for="item in payableBatchPayInfo">
                        <li v-for="row in item.payable_list">
                            <p>
                                应付编号：<span class="link-label">{{ row.payable_no }}</span>
                            </p>
                            <template v-if="payableDetails.basic_info.source_type === 'purchase'">
                                <p>供应商名称：{{ row.detail && row.detail.supplier_name }}</p>
                                <p>
                                    采购编号：<span class="link-label" @click="handleClickRelateId(row.relate_id)">{{ row.detail && row.detail.purchase_no }}</span>
                                </p>
                            </template>
                            <template v-else-if="payableDetails.basic_info.source_type === 'order_return'">
                                <p>客户公司：{{ row.customer_info && row.customer_info.name }}</p>
                                <p>订单编号：<span class="link-label" @click="handleClickOrderDetail(row.detail && row.detail.order_no)">{{ row.detail && row.detail.order_no }}</span></p>
                            </template>
                            <template v-else>
                                <p>收款方：{{ row.detail && row.detail.payee_name }}</p>
                            </template>
                            <p>
                                审批编号：<span class="link-label">{{ row.approval_id }}</span>
                            </p>
                            <div class="mobile_detail_head_user_wrap">
                                申请人：
                                <div class="mobile_detail_head_user" v-if="row.uid_info" @click="handleClickUserInfo(row.uid_info)">
                                    <img :src="row.uid_info.avatar ? row.uid_info.avatar : defaultImg" alt="" />
                                    <span class="ellipsis">{{ row.uid_info && row.uid_info.name }}</span>
                                </div>
                            </div>
                            <div class="payable_list_item_amount">
                                <div>
                                    <div class="payable_list_item_amount_percent percent_bg1">
                                        应付金额：¥{{ Number(row.payable_amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                                    </div>
                                </div>
                                <div>
                                    <div class="payable_list_item_amount_percent percent_bg2">
                                        已付金额：¥{{ Number(row.paid_amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                                    </div>
                                </div>
                            </div>
                        </li>
                        <div class="form_module_content">
                            <p>备注：{{ item.remarks }}</p>
                            <p>支付凭证：</p>
                            <div v-if="item.voucher && item.voucher.length">
                                <ul class="voucher_list">
                                    <li :key="imgIndex" class="voucher_item" v-for="(img, imgIndex) in item.voucher" @click="handleClickPreviewImg(imgIndex, item.voucher)">
                                        <van-image :src="img" alt=""> </van-image>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </template>
                </ul>
            </template>
        </div>
        <div class="add_footer_wrap" v-if="
            payableDetails.basic_info.payment_status == 1 ||
            (payableDetails.basic_info.payment_status == 4 && payableDetails.basic_info.unpaid_amount != 0)
        ">
            <van-button round block type="info" @click="handleClickPayment">去付款</van-button>
        </div>
        <userDetailDialog v-if="userDetailPopupShow" :userDetailPopupShow.sync="userDetailPopupShow" :userId="userDetailId" />
    </div>
</template>
<script>
import { PayableDetail, PayableMergedPaymentRecords } from "@/api";
import { ImagePreview } from "vant";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import userDetailDialog from "@/components/mComponents/userDetailDialog";
export default {
    name: "PayableDetails",
    components: { ReturnNavBar, userDetailDialog },
    data() {
        return {
            payable_no: "",
            loading: false,
            defaultImg: require("@/assets/images/default.jpg"),
            payableDetails: {
                basic_info: {}, // 基础信息
                cancel_info: {},
                payee_info: {}, //收款方信息
                payment_records: [], //付款记录
                detail: {}, // 差异字段
            },
            payableBatchPayInfo: [],
            batchRowArray: {}, // 记录合并行
            payTypeList: [
                { name: "电汇", value: 1 },
                { name: "微信", value: 2 },
                { name: "支付宝", value: 3 },
                { name: "现金", value: 4 },
                { name: "银行承兑", value: 5 },
                { name: "商业承兑", value: 6 },
                { name: "支票", value: 7 },
            ],
            // 人员详细信息
            userDetailPopupShow: false,
            userDetailId: "",
        };
    },
    activated() {
        if (this.$route.query) {
            this.payable_no = this.$route.query.payable_no;
            if (this.payable_no) {
                this.getPayableDetail();
                this.getPayableMergedPaymentRecords();
            }
        }
    },
    created() {
        if (this.$route.query) {
            this.payable_no = this.$route.query.payable_no;
            if (this.payable_no) {
                this.getPayableDetail();
                this.getPayableMergedPaymentRecords();
            }
        }
    },
    methods: {
        // 人员详细信息
        handleClickUserInfo(info) {
            this.userDetailId = info.id;
            this.userDetailPopupShow = true;
        },
        // 应付详情
        getPayableDetail() {
            this.loading = true
            PayableDetail({ payable_no: this.payable_no }).then((res) => {
                if (res.code === 200) {
                    const data = res.data || {};
                    this.payableDetails = data;
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        // 图片预览
        handleClickPreviewImg(index, images) {
            ImagePreview({
                images,
                startPosition: index,
            });
        },
        // 批量支付记录
        getPayableMergedPaymentRecords() {
            PayableMergedPaymentRecords({ payable_no: this.payable_no }).then((res) => {
                if (res.code === 200) {
                    const data = res.data || [];
                    this.payableBatchPayInfo = data;
                    // var batchRowArray = {};
                    // var batchData = [];
                    // data.forEach((item) => {
                    //     if (item.payable_list.length) {
                    //         item.payable_list = item.payable_list.map((payableItem) => ({
                    //             ...payableItem,
                    //             remarks: item.remarks,
                    //             voucher: item.voucher,
                    //         }));
                    //         batchRowArray[batchData.length > 0 ? batchData.length : 0] = item.payable_list.length;
                    //         batchData.concat(item.payable_list);
                    //         batchData = [...batchData, ...item.payable_list];
                    //     }
                    // });
                    // this.payableBatchPayInfo = batchData;
                    // this.batchRowArray = batchRowArray;
                }
            });
        },
        // 付款
        handleClickPayment(row) {
            this.$router.push({
                name: "PayablePayment",
                query: {
                    payable_no: this.payable_no,
                    type: "payment",
                },
            });
        },
        // 采购详情
        handleClickRelateId(purchaseId) {
            this.$router.push({
                name: "purchase_detail",
                query: {
                    purchase_id: purchaseId,
                },
            });
        },
        // 订单详情
        handleClickOrderDetail(order_no) {
            this.$router.push({
                name: "OrderDetail",
                // params: {
                //     isPush: true,
                // },
                query: {
                    order_id: order_no,
                    name: order_no,
                    query_type: "order_no",
                },
            });
        },
        // 查看客户详情
        handleClickCustomerDetail(customer_id, customer_name) {
            this.$router.push({
                name: "CustomerPrivateSeasDetail",
                // params: {
                //     isPush: true,
                // },
                query: {
                    customer_id,
                    name: customer_name,
                },
            });
        },
        // 审批详情
        handleClickApprovalDetail(approval_id) {
            // this.$showApprovalDetail({
            //     approval_id,
            // }).then((res) => { });
        },
    },
};
</script>
<style lang="scss" scoped>
.ml_10 {
    margin-left: 10px;
}

.payable_details_wrap {
    background: rgba(255, 255, 255, 1);

    .mobile_container {
        background: rgba(255, 255, 255, 1);

        .form_module_title {
            font-weight: 700;
            font-size: 14px;
            line-height: 24px;
            color: #333333;
            padding: 10px 16px 10px 28px;
            position: relative;

            &::before {
                content: "";
                width: 4px;
                height: 22px;
                opacity: 1;
                border-radius: 20px;
                background: #2990ff;
                position: absolute;
                left: 16px;
            }
        }

        .form_module_content {
            padding: 0 16px;

            &>p,
            &>div {
                font-size: 14px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 22px;
                color: rgba(102, 102, 102, 1);
                margin-bottom: 8px;
            }
        }

        ul {
            padding: 0 16px;

            li {
                border-radius: 6px;
                background: rgba(249, 249, 249, 1);
                padding: 8px 10px 2px;
                margin-bottom: 8px;

                &>p,
                &>div {
                    font-size: 14px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 22px;
                    color: rgba(102, 102, 102, 1);
                    margin-bottom: 8px;
                }

                .payable_list_item_amount {
                    width: 100%;
                    padding: 4px;
                    border-radius: 4px;
                    background: #ffffff;
                    border: 2px solid rgba(237, 240, 244, 1);

                    &>div {
                        height: 24px;
                        display: flex;
                        justify-content: space-between;
                        gap: 4px;
                    }

                    &>div+div {
                        margin-top: 4px;
                    }

                    .payable_list_item_amount_percent {
                        width: 100%;
                        height: 24px;
                        padding: 0 8px;
                        font-size: 12px;
                        font-weight: 400;
                        letter-spacing: 0px;
                        line-height: 24px;
                        color: rgba(102, 102, 102, 1);
                        border-radius: 4px;
                        box-sizing: border-box;
                    }

                    .percent_bg1 {
                        background-color: rgba(41, 144, 255, 0.16);
                    }

                    .percent_bg2 {
                        background-color: rgba(41, 144, 255, 0.08);
                        padding-right: 0;
                    }

                    .percent_bg3 {
                        background-color: rgba(0, 0, 0, 0.04);
                        color: rgba(51, 51, 51, 1);
                        font-weight: 700;
                        text-align: right;
                        padding-left: 0;
                    }
                }
            }

            .form_module_content {
                padding: 0;
            }
        }

        .voucher_list {
            margin-top: 10px;
            padding: 0;
            display: flex;
            gap: 8px;

            .voucher_item {
                width: 44px;
                height: 44px;
                cursor: pointer;
                position: relative;
                text-align: center;
                line-height: 44px;
                border-radius: 4px;

                .van-image {
                    max-width: 100%;
                    max-height: 100%;
                }

                img {
                    max-width: 100%;
                    max-height: 100%;
                    object-fit: cover;
                }

                .icon-guanbi_dise {
                    position: absolute;
                    right: -8px;
                    top: -8px;
                    cursor: pointer;
                    font-size: 16px;
                    color: rgba(191, 191, 191, 1);
                    line-height: 16px;
                }
            }
        }
    }
}

.add_footer_wrap {
    padding: 5px 16px;
    background-color: #ffffff;

    .van-button {
        border-radius: 8px;
        height: 38px;
        background-color: rgba(41, 144, 240, 1);
        border-color: rgba(41, 144, 240, 1);
    }
}
</style>
<style lang="scss">
.van-image-preview__overlay {
    background: rgba(0, 0, 0, 0.3);
}

.van-image-preview {
    .van-image-preview__index {
        top: auto;
        bottom: 26px !important;
        text-shadow: none;
    }
}
</style>
